module.exports = __webpack_public_path__ + "img/ceo_way_cho_02.31fa7c93.png";